<div class="flex flex-col h-full min-h-0">
  <div #scrollWrap class="flex-1 min-h-0 overflow-y-auto" (scroll)="onScroll()">
    @for (msg of messages; track msg.id) {
      <div
        class="flex items-start gap-[10px] rounded-[8px] py-[12px] px-[16px]"
        [class.bg-[#FAFAFA]]="selectedIds.has(msg.id)"
        (click)="onMessageRowClick(msg)"
      >
        @if (selectionMode) {
          <label class="shrink-0 self-center flex items-center cursor-pointer">
            <input
              type="checkbox"
              class="w-[16px] h-[16px] accent-[var(--color-primary-b1)]"
              [checked]="selectedIds.has(msg.id)"
            />
          </label>
        }
        <div class="flex-1 min-w-0">
          <fl-message
            [message]="msg"
            [parentMessage]="messages | messageParent: msg"
            [replying]="replyMessageId === msg.id"
            (avatarClick)="selectionMode ? null : onAvatarClick($event)"
          >
            <!-- 学生作答详情：选择题选项 / 主观题图片与分数，题组横向排列在姓名栏 -->
            @if (msg.exerciseDetail?.length) {
              <ng-container nameSlot>
                <!-- 姓名后的分割线（仅在存在作答块时显示） -->
                <span class="w-px h-[12px] bg-neutral-n4"></span>
                <div class=" flex shrink-0 items-center gap-[4px]" >
                  @for (d of msg.exerciseDetail; track $index) {
                    <fl-message-exercise-detail [detail]="d"></fl-message-exercise-detail>
                  }
                </div>
              </ng-container>

            }
          </fl-message>
        </div>
      </div>
    } @empty {
      @if (!loading) {
        <div class="py-[40px] text-center text-neutral-n4">暂无消息</div>
      }
    }

    @if (loading) {
      <div class="py-[16px] flex justify-center">
        <nz-spin nzSize="small"></nz-spin>
      </div>
    }
  </div>
</div>
